import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type GetMyBettieAutoTopUpResponse =
  paths['/api/v1/bettie_auto_topups/me']['get']['responses'][200]['content']['application/json']['bettieAutoTopup'];

export type PauseBettieAutoTopUpResponse =
  paths['/api/v1/bettie_auto_topups/{uuid}/pause']['post']['responses'][200]['content']['application/json']['bettieAutoTopup'];

export type ActivateBettieAutoTopUpResponse =
  paths['/api/v1/bettie_auto_topups/{uuid}/activate']['post']['responses'][200]['content']['application/json']['bettieAutoTopup'];

export type ChangeAutoTopUpProductResponse =
  paths['/api/v1/bettie_auto_topups/{uuid}/change_product']['post']['responses'][200]['content']['application/json']['bettieAutoTopup'];

export type GetAutoTopUpRegistrationProductResponse =
  paths['/api/v1/bettie_auto_topups/registration_product']['get']['responses'][200]['content']['application/json']['bettieProduct'];

export type CancelAutoTopUpResponse =
  paths['/api/v1/bettie_auto_topups/{uuid}/cancel']['post']['responses'][200]['content']['application/json']['bettieAutoTopup'];

export async function getMyBettieAutoTopUp(): Promise<GetMyBettieAutoTopUpResponse | undefined> {
  const { data, error } = await client.GET('/api/v1/bettie_auto_topups/me', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) return undefined;
  return data.bettieAutoTopup;
}

export async function pauseBettieAutoTopUp(
  bettieAutoTopUpId: string
): Promise<GetMyBettieAutoTopUpResponse> {
  const { data, error } = await client.POST('/api/v1/bettie_auto_topups/{uuid}/pause', {
    params: { path: { uuid: bettieAutoTopUpId } },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when pausing bettie auto top up');
  return data.bettieAutoTopup;
}

export async function activateBettieAutoTopUp(
  bettieAutoTopUpId: string
): Promise<ActivateBettieAutoTopUpResponse> {
  const { data, error } = await client.POST('/api/v1/bettie_auto_topups/{uuid}/activate', {
    params: { path: { uuid: bettieAutoTopUpId } },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when activating bettie auto top up');
  return data.bettieAutoTopup;
}

export async function changeAutoTopUpProduct(
  bettieAutoTopUpId: string,
  productId: string
): Promise<ChangeAutoTopUpProductResponse> {
  const { data, error } = await client.POST('/api/v1/bettie_auto_topups/{uuid}/change_product', {
    params: { path: { uuid: bettieAutoTopUpId } },
    body: {
      bettie_auto_topup: {
        product_id: productId
      }
    },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when changing auto top up product');
  return data.bettieAutoTopup;
}

export async function getAutoTopUpRegistrationProduct(): Promise<GetAutoTopUpRegistrationProductResponse> {
  const { data, error } = await client.GET('/api/v1/bettie_auto_topups/registration_product', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting auto top up registration product');
  return data.bettieProduct;
}

export async function cancelAutoTopUp(bettieAutoTopUpId: string): Promise<CancelAutoTopUpResponse> {
  const { data, error } = await client.POST('/api/v1/bettie_auto_topups/{uuid}/cancel', {
    params: { path: { uuid: bettieAutoTopUpId } },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when canceling auto top up');
  return data.bettieAutoTopup;
}